import { render } from "./go-back.svg?vue&type=template&id=2a0276c8"
const script = {}
script.render = render

export default script